//import $ from 'jquery';
// Load typeahead and bloodhound
import Bloodhound from 'corejs-typeahead';
import typeahead from 'corejs-typeahead';
import Handlebars from 'handlebars';

(function(){
	'use strict';
	if($('.smp-recycle-finder').length > 0){
		var dataUrl = $('.smp-recycle-finder').data('target');
		var tags = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name', 'alternateNames'),
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			prefetch: {
				url: dataUrl,
				cache: true,
				transform: function(response) {
					return $.map(response, function (tag) {
						return {
							id: tag.id,
							name: tag.name,
							alternateNames: tag.alternateNames,
							type: tag.type,
							instructions: tag.instructions,
							otherInstructions: tag.otherInstructions
						}
					});
				}
			}
		});

		$('.smp-recycle-finder .typeahead').typeahead({
			hint: true,
			minLength: 3,
			highlight: true
		}, {
			name: 'tags-dataset',
			source: tags,
			display: 'name'
		});

		$('.smp-recycle-finder .typeahead').bind('typeahead:select', function(ev, suggestion) {
			console.log('Selection: ', suggestion);
			loadResults(suggestion);
		});


		var loadResults = function(suggestion){
			
			var source = document.getElementById('recycle-finder-template').innerHTML;
			var template = Handlebars.compile(source);
			var context = suggestion;
			var html = template(context);
			$('#recycle-finder-content').html(html);
		};
	}
	

	Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
		return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
	});

}());
